"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsletterCrossSellEntryPoint = exports.OrganizationCrossSellEventType = void 0;
var OrganizationCrossSellEventType;
(function (OrganizationCrossSellEventType) {
    OrganizationCrossSellEventType["HasSeenBanner"] = "has_seen_banner";
    OrganizationCrossSellEventType["HasDismissed"] = "has_dismissed";
    OrganizationCrossSellEventType["HasClickedCta"] = "has_clicked_cta";
})(OrganizationCrossSellEventType || (exports.OrganizationCrossSellEventType = OrganizationCrossSellEventType = {}));
var NewsletterCrossSellEntryPoint;
(function (NewsletterCrossSellEntryPoint) {
    NewsletterCrossSellEntryPoint["CampaignHub"] = "campaign_hub_banner";
    NewsletterCrossSellEntryPoint["EmailStats"] = "email_stats_banner";
    NewsletterCrossSellEntryPoint["CommunicationsInlineCard"] = "communications_inline_card";
})(NewsletterCrossSellEntryPoint || (exports.NewsletterCrossSellEntryPoint = NewsletterCrossSellEntryPoint = {}));
